import React, { useContext, useEffect, useRef, useState} from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MyContext } from '../../globalContext';
import CancelIcon from '@mui/icons-material/Cancel';
import PropTypes from 'prop-types';


const theme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    '&::placeholder': {
                        color: '#333', // Change this to your desired color
                        opacity: 1, // Optional: to ensure the color is fully applied
                        fontSize: '16px !important',
                        fontFamily: 'Ubuntu, Arial, Helvetica, Verdana, sans-serif !important',
                    },
                    '& .Mui-focused .MuiInputBase-input::placeholder': {
                        color: 'green !important', // Placeholder color when focused
                         fontSize: '16px !important',
                        fontFamily: 'Ubuntu, Arial, Helvetica, Verdana, sans-serif !important',
                    },


                },

            },
        },

    },
});

const AddressLookup = ({ errorZip, errorMessageZip }) => {
    const inputRef = useRef(null);
    const { t } = useTranslation();
    const { setAddressData, setFullZipData, dropValue} = useContext(MyContext);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
   
    
   

    useEffect(() => {
        setError(errorZip);
        setErrorMessage(errorMessageZip);
    }, [errorZip]);

    useEffect(() => {
        if (window.google) {
            initializeGoogleMaps();
        } else {
            window.onload = initializeGoogleMaps;
        }
    }, []);

    const initializeGoogleMaps = () => {
        const google = window.google;
        const input = document.getElementById("pac-input");
        if (!input) return;

        setupAutocomplete(google, input);
        checkGeolocationSupport(google, input);
    };

    const setupAutocomplete = (google, input) => {
        const autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['(regions)'],
            componentRestrictions: { country: "us" }
        });

        autocomplete.addListener("place_changed", () => handlePlaceChanged(autocomplete));
    };

    const handlePlaceChanged = (autocomplete) => {
        try {
            const place = autocomplete.getPlace();
            
            setFullZipData(place?.formatted_address);           
            if (isInvalidPlace(place)) return;            
            const address = extractAddressComponents(place.address_components);
            if(address.city == "" && address.zipCode == "" && address.state != ""){
                address.zipCode = address.state + "," + address.country;
                if(address.county != "") {
                    address.zipCode = address.county + "," + address.zipCode;
                }
                address["addressValidated"]=false; 
            }
            else{
            address["addressValidated"]=true;
            }          
            validateAndSetAddress(address);
        } catch (e) {
            logError(e);
        }
    };

    const isInvalidPlace = (place) => {
        if (!place.geometry) {
            return true;
        }
        return false;
    };

    const logError = (errorVal) => {
        console.error("Error occurred while fetching place details:", errorVal);
    };

    const extractAddressComponents = (addressComponents) => {
       
        console.log("addressComponents", addressComponents);
        const address = {
            "streetNumber": "",
            "route": "",
            "city": "",
            "state": "",
            "zipCode": "",
            "country": "",
            "county": "",
            "addressValidated":false
        };

        const addressMapping = {
            'street_number': 'streetNumber',
            'route': 'route',
            'locality': 'city',
            'administrative_area_level_1': 'state',
            'postal_code': 'zipCode',
            'country': 'country',
            "administrative_area_level_2": 'county',
            
        };

        addressComponents.forEach(component => {
            component.types.forEach(type => {
                const key = addressMapping[type];
                if (key){                  
 
                    address[key] = type === 'administrative_area_level_1' ? component.short_name : component.long_name;
                }
            });
        });
     
        
        return address;
       

        
    };

    const validateAndSetAddress = (address) => {
        if (isAddressInvalid(address)) {
            setError(true);
            setErrorMessage(errorMessageZip);
        } else {
            clearError();
        }

        setAddressData(address);
    };

    const isAddressInvalid = (address) => {
        return address["zipCode"] === "" && address["city"] === "" && address["state"] === "" ;
    };

    const clearError = () => {
        setError(false);
        setErrorMessage("");
    };

    const checkGeolocationSupport = (google, input) => {
        if (!isGeolocationSupported()) {
            logGeolocationNotSupported();
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => handleGeolocationSuccess(position, google, input),
            handleGeolocationError
        );
    };

    const isGeolocationSupported = () => 'geolocation' in navigator;

    const logGeolocationNotSupported = () => {
        console.error("Geolocation is not supported by this browser.");
    };

    const handleGeolocationSuccess = (position, google, input) => {
        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;
        getZipCode(google, input, userLat, userLng);
    };

    const handleGeolocationError = (errorVal) => {
        console.error("Error getting user's location: ", errorVal);
    };

    const getZipCode = (google, input, lat, lng) => {
        const geocoder = new google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK" && results[0]) {                
                const zipCode = extractZipCode(results[0].address_components);
                handleZipCode(zipCode, input);
            }
        });
    };

    const extractZipCode = (addressComponents) => {
        for (const component of addressComponents) {
            if (component.types.includes("postal_code")) {
                return component.long_name;
            }
        }
        return "";
    };

    const handleZipCode = (zipCode, input) => {
       
        if (zipCode) {
           
            setInputValue(input, zipCode);
            updateAddressData(zipCode);
        }
    };

    const setInputValue = (input, zipCode) => {
       
        if (input && (!input.value || input.value.length === 0)) {
            input.value = zipCode;
        }
       
    };
   

    const updateAddressData = (zipCode) => {
        if (zipCode) {
            const newAddress = {
                "streetNumber": "",
                "route": "",
                "city": "",
                "state": "",
                "zipCode": zipCode,
                "country": "", 
                "county": "",
                "addressValidated":false
            };

            validateAddress(newAddress);
            setAddressData(newAddress);
        }
    };

    const validateAddress = (address) => {
       
        if (address.zipCode === "" && address.city === "" &&  dropValue === "") {
            setError(true);
            setErrorMessage(errorMessageZip);
        } else {
            setError(false);
            setErrorMessage("");
        }
    };


    console.log("ipdrop", dropValue);
    const handleAutocompleteInputChange = (event) => {     
        
        if (event.target.value === "") {
            setAddressData({
                "streetNumber": "",
                "route": "",
                "city": "",
                "state": "",
                "zipCode": "",
                "country": "",               
                "county": "",
                "addressValidated":false
            });
        } else {
            clearError();
            setAddressData({
                "streetNumber": "",
                "route": "",
                "city": "",
                "state": "",
                "county": "",
                "zipCode": event.target.value,
                "country": "",                
                "addressValidated":false
            });
        }
    };  
    

    return (
        <ThemeProvider theme={theme}>
            <TextField
                id="pac-input"
                type="text"
                className="cityinput"
                size="small"
                variant="outlined"
                color="success"
                name="txtcity"
                inputProps={{ 'aria-label': t(`cityStateZip`) }}
                placeholder={t(`cityStateZip`)}
                ref={inputRef}
                // value={selectedValue}
                onChange={(event) => { handleAutocompleteInputChange(event) }}
            />
             {error && <div className="error-bubblezip">
                            <div><CancelIcon className="error-icon" /></div>
                            {errorMessage}</div>
                        }
            </ThemeProvider>
       
    );
};

AddressLookup.propTypes = {
    errorZip: PropTypes.boolean,
    errorMessageZip: PropTypes.string,
   
  };
export default AddressLookup;